import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import WebFont from "webfontloader";
import { datadogRum } from "@datadog/browser-rum";
import {
  privMemberId,
  applicationId,
  clientToken,
  site,
  env,
  sessionSampleRate,
  premiumSampleRate,
} from "./utils";

const App = () => {
  useEffect(() => {
    WebFont.load({ google: { families: ["Poppins", "Inter"] } });
    DDRumInit();
  }, []);
  return <RouterProvider router={router} />;
};

const DDRumInit = () => {
  const memberId = localStorage.getItem(privMemberId);
  if (memberId) {
    const payload = {
      applicationId,
      clientToken,
      site,
      env,
      sessionSampleRate: Number.parseInt(sessionSampleRate),
      premiumSampleRate: Number.parseInt(premiumSampleRate),
      service: "componente-reducido",
      trackUserInteractions: true,
      enableExperimentalFeatures: ["clickmap"],
      version: "1.0.6",
      allowedTracingUrls: [
        /http(s?):\/\/(dev|qa|prod)\.reduced\.digitalmxce\.com/,
        /session-replay-datadoghq\.com/,
      ],
    };
    datadogRum.init(payload);
    datadogRum.setUser({ id: memberId });
  }
  return;
};

export default App;
